module.exports = __webpack_public_path__ + "static/media/1.351800e9.JPG";